// extracted by mini-css-extract-plugin
module.exports = {"getStarted":"GetStarted_getStarted__3vw_z","title":"GetStarted_title__3t_O_","actionButtonContainer":"GetStarted_actionButtonContainer__1yfgB"};